import React from "react";
import Icon from "components/AppIcon";
import Button from "components/ui/Button";

const SaveConfirmModal = ({ isOpen, onConfirm, onCancel, isSaving, savedSuccess }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center z-50 px-4" style={{ backgroundColor: "rgba(0,0,0,0.5)" }}>
      <div className="rounded-xl border p-6 w-full max-w-md shadow-elevation-4" style={{ backgroundColor: "var(--color-card)", borderColor: "var(--color-border)" }}>
        {savedSuccess ? (
          <div className="text-center">
            <div className="w-14 h-14 rounded-full flex items-center justify-center mx-auto mb-4" style={{ backgroundColor: "rgba(5,150,105,0.12)" }}>
              <Icon name="CheckCircle" size={28} color="var(--color-success)" />
            </div>
            <h3 className="font-heading font-700 text-lg mb-2" style={{ color: "var(--color-foreground)" }}>¡Configuración guardada!</h3>
            <p className="text-sm font-caption" style={{ color: "var(--color-muted-foreground)" }}>Los cambios han sido aplicados exitosamente al sistema.</p>
          </div>
        ) : (
          <>
            <div className="flex items-center gap-3 mb-4">
              <div className="w-10 h-10 rounded-lg flex items-center justify-center" style={{ backgroundColor: "rgba(217,119,6,0.12)" }}>
                <Icon name="AlertTriangle" size={20} color="var(--color-warning)" />
              </div>
              <div>
                <h3 className="font-heading font-700 text-base" style={{ color: "var(--color-foreground)" }}>Confirmar cambios</h3>
                <p className="text-xs font-caption" style={{ color: "var(--color-muted-foreground)" }}>Esta acción afectará la configuración del sistema</p>
              </div>
            </div>
            <p className="text-sm font-caption mb-5" style={{ color: "var(--color-foreground)" }}>
              ¿Está seguro de que desea guardar los cambios de configuración? Algunos cambios tendrán efecto inmediato y podrían afectar a los usuarios activos.
            </p>
            <div className="flex gap-3 justify-end">
              <Button variant="outline" onClick={onCancel} disabled={isSaving}>Cancelar</Button>
              <Button variant="default" loading={isSaving} iconName="Save" iconPosition="left" onClick={onConfirm}>
                Guardar configuración
              </Button>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default SaveConfirmModal;